export const EMIT_LOGOUT_ON_ERROR = 'EMIT_LOGOUT_ON_ERROR';
export const ON_LOGOUT = 'ON_LOGOUT';
